import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

// Import modules
import auth from './modules/auth'
import iot from './modules/iot'
import dashboard from './modules/dashboard'
import sensors from './modules/sensors'
import devices from './modules/devices'
import users from './modules/users'
import alerts from './modules/alerts'
import reports from './modules/reports'

Vue.use(Vuex)

// Configure persistence
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) => ({
    auth: {
      token: state.auth.token,
      user: state.auth.user,
      isAuthenticated: state.auth.isAuthenticated
    },
    settings: state.settings
  })
})

export default new Vuex.Store({
  modules: {
    auth,
    iot,
    dashboard,
    sensors,
    devices,
    users,
    alerts,
    reports
  },
  state: {
    loading: false,
    error: null,
    settings: {
      theme: 'light',
      language: 'es',
      notifications: true,
      autoRefresh: true,
      refreshInterval: 30000 // 30 seconds
    },
    user: null,
    isAuthenticated: false,
    sensors: [],
    alerts: []
  },
  mutations: {
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    CLEAR_ERROR(state) {
      state.error = null
    },
    UPDATE_SETTINGS(state, settings) {
      state.settings = { ...state.settings, ...settings }
    },
    SET_USER(state, user) {
      state.user = user
      state.isAuthenticated = !!user
    },
    SET_SENSORS(state, sensors) {
      state.sensors = sensors
    },
    SET_ALERTS(state, alerts) {
      state.alerts = alerts
    }
  },
  actions: {
    setLoading({ commit }, loading) {
      commit('SET_LOADING', loading)
    },
    setError({ commit }, error) {
      commit('SET_ERROR', error)
    },
    clearError({ commit }) {
      commit('CLEAR_ERROR')
    },
    updateSettings({ commit }, settings) {
      commit('UPDATE_SETTINGS', settings)
    },
    login({ commit }, user) {
      commit('SET_USER', user)
    },
    logout({ commit }) {
      commit('SET_USER', null)
    },
    updateSensors({ commit }, sensors) {
      commit('SET_SENSORS', sensors)
    },
    updateAlerts({ commit }, alerts) {
      commit('SET_ALERTS', alerts)
    },
    async initializeApp({ dispatch }) {
      try {
        await dispatch('setLoading', true)
        
        // Initialize all modules
        await Promise.all([
          dispatch('auth/initialize'),
          dispatch('iot/initialize'),
          dispatch('dashboard/initialize'),
          dispatch('sensors/initialize'),
          dispatch('devices/initialize'),
          dispatch('alerts/initialize')
        ])
        
      } catch (error) {
        // Error initializing app - handled silently
        dispatch('setError', 'Error al inicializar la aplicación')
      } finally {
        await dispatch('setLoading', false)
      }
    }
  },
  getters: {
    isLoading: state => state.loading,
    error: state => state.error,
    settings: state => state.settings,
    isAuthenticated: state => state.isAuthenticated,
    user: state => state.user,
    sensors: state => state.sensors,
    alerts: state => state.alerts
  },
  plugins: [vuexLocal.plugin]
}) 


// WEBPACK FOOTER //
// ./src/store/index.js